
/* System defined core library */
import { Component, OnInit, OnDestroy } from '@angular/core';

/* User defined library/components */
import { SelectedExamDetailService } from '../shared/services/selected-exam-detail.service';
import { UtilityService } from '../../shared/services/utility.service';

/* User defined enums/constants */
import { ComponentType } from '../../shared/enums/scheduling.enum';

@Component({
  selector: 'app-cancellation-appointment',
  templateUrl: './cancellation-appointment.component.html'
})

export class CancellationAppointmentComponent implements OnDestroy, OnInit {

  /* Constructor declaration with required injected services */
  constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private utilityService: UtilityService
  ) {

  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.CancellationAppointment)) return;
  }

  /* Reset The data in service if component is unloaded */
  ngOnDestroy() {
    this.selectedExamDetailService.setCountry(null);
    this.selectedExamDetailService.setState(null);
    this.selectedExamDetailService.setSlot(null);
    this.selectedExamDetailService.setEligibility(null);
    this.selectedExamDetailService.setClient(null);
    this.selectedExamDetailService.setProgram(null);
    this.selectedExamDetailService.SetCandidateDataSource(null);
    this.selectedExamDetailService.setHold(null);
    this.selectedExamDetailService.setExam(null);
    this.selectedExamDetailService.setRegion(null);
    this.selectedExamDetailService.setSelectedLocation(null);
  }
}
